import { Component, ElementRef, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { LoadingService } from 'src/app/services/loading.service';
import { ReCaptchaService } from 'src/app/services/recaptcha.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
    constructor(
        private auth: AuthService,
        public loading: LoadingService,
        private title: Title,
        private el: ElementRef,
        private reCaptchaService: ReCaptchaService,
        private toastr: ToastrService
    ) { }
    theForm = new FormGroup({
        email: new FormControl(),
    });
    isSuccess = false;

    async submitForm(loginForm: any): Promise<void> {
        if (!loginForm.valid) {
            this.el.nativeElement.querySelectorAll('[formcontrolname].ng-invalid')?.[0]?.focus();

            return;
        }

        this.loading.start();
        loginForm.disable();

        try {
            const fdata = this.theForm.value;
            const token = await this.reCaptchaService.generateTokenAsync('forgot_password');
            const res: any = await this.auth.forgotPassword({ email: fdata.email, token });

            loginForm.enable();

            if (res.success) {
                this.isSuccess = true;
                return;
            }

            if (res.response?.wrong) {
                Object.keys(res.response.wrong).forEach((key) => {
                    loginForm.get(key)?.setErrors({
                        serverError: res.response.wrong[key][0]
                    });

                    this.el.nativeElement.querySelectorAll(`[formcontrolname="${key}"]`)?.[0]?.focus();
                });
            }

            const title = res.response?.message || 'Oops';
            const desc = res.response?.description || 'Error';

            this.toastr.error(desc, title);

        } catch (error) {
            loginForm.enable();
            console.error(error);
            this.toastr.error('Failed to load Captcha. Please refresh the page or try again.', 'Error');

        } finally {
            this.loading.done();
        }
    }

    ngOnInit(): void {
        this.title.setTitle('Forgot Password | MFGM - CMS');
    }

}
